import VideocamIcon from '@material-ui/icons/Videocam';
import PhonelinkIcon from '@material-ui/icons/Phonelink';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import PowerIcon from '@material-ui/icons/Power';
import UpdateIcon from '@material-ui/icons/Update';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import RefreshIcon from '@material-ui/icons/Refresh';
import VideoCallIcon from '@material-ui/icons/VideoCall';

import { navigatorDetails } from 'UTILS/navigator';

export const getOtherCameraSupportText = ({ context, os = navigatorDetails.os } = {}) => {
  switch (os) {
    case 'iOS':
    case 'Android':
      return `${context}-tryTestingAnotherCameraByGoingBackToTheCameraCheckAndSelectingItInTheList`; // TODO: Deprecate when testing all cameras
    default:
      return `${context}-tryTestingAnotherCameraByGoingBackToTheCameraCheckAndSelectingItInTheList-youCanPlugACameraInItWillBeAutomaticallyAddedToTheList`;
  }
};

export const getCameraNotFoundHintList = ({ os = navigatorDetails.os } = {}) => {
  const hintList = [];
  if (os !== 'Android' && os !== 'iOS') {
    hintList.push({
      icon: PowerIcon,
      title: 'checkTheConnections',
      text: 'ifYourCameraIsExternalMakeSureThatItIsConnectedToYourDevice-tryToDisconnectAndReconnectItOnAnotherUsbPortThenRestartTheCheck',
    });
  }
  if (os === 'Windows') {
    hintList.push({
      icon: UpdateIcon,
      title: 'updateTheDriverSoftware',
      text: 'ifYourCameraNeedsADriverSoftwareMakeSureItIsUpToDate',
      buttonList: [{
        href: 'updateDriverSupportLink',
        label: 'stepByStep',
      }],
    });
  }
  return hintList;
};

export const CAMERA_RESULT_MAP = {
  'definition_too_low': {
    message: 'yourCameraDefinitionIsTooLow',
    title: 'howCanIGetABetterDefinition',
    hintList: [
      {
        icon: VideocamIcon,
        title: 'tryAnotherCamera',
        text: getOtherCameraSupportText({ context: 'yourCurrentCameraDefinitionIsTooLow' }),
      },
      {
        icon: PhonelinkIcon,
        title: 'tryAnotherComputerOrSmartphone',
        text: 'ifYouDontHaveOtherCameraOnYourCurrentDeviceTryOpeningTheVideoConferenceLinkOnAnotherDevice-smartPhonesUsuallyHaveGoodCameras',
      },
    ],
  },
  'definition_low': {
    message: 'yourCameraDefinitionCouldBeImproved',
    title: 'howCanIGetABetterDefinition',
    hintList: [
      {
        icon: VideocamIcon,
        title: 'tryAnotherCamera',
        text: getOtherCameraSupportText({ context: 'yourCurrentCameraDefinitionIsLow' }),
      },
      {
        icon: PhonelinkIcon,
        title: 'tryAnotherComputerOrSmartphone',
        text: 'ifYouDontHaveOtherCameraOnYourCurrentDeviceTryOpeningTheVideoConferenceLinkOnAnotherDevice-smartPhonesUsuallyHaveGoodCameras',
      },
    ],
  },
  'definition_high_enough': {
    message: 'yourCameraDefinitionIsGoodEnough',
  },
  'definition_check_impossible': {
    message: 'videoDefinitionCheckImpossible',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: VideocamIcon,
        title: 'tryAnotherCamera',
        text: getOtherCameraSupportText({ context: 'yourCurrentCameraDefinitionCanNotBeTested' }),
      },
      {
        icon: PhonelinkIcon,
        title: 'tryAnotherComputerOrSmartphone',
        text: 'ifYouDontHaveOtherCameraOnYourCurrentDeviceTryOpeningTheVideoConferenceLinkOnAnotherDevice-smartPhonesUsuallyHaveGoodCameras',
      },
      {
        icon: SkipNextIcon,
        title: 'skipTheTest',
        text: 'thereIsASmallChanceThatYourCameraCanStillPerformVideoConferences-ifTheOtherSuggestionsDidNotWorkYouCanSkipThisCheckAndHopeItWillWorkDuringTheVideoConference',
      },
    ],
  },
  'camera_detected': {
    message: 'cameraSuccessfullyDetected',
  },
  'camera_not_detected': {
    message: 'cameraNotDetected',
    title: 'howCanIMakeMyCameraDetected',
    hintList: [
      ...getCameraNotFoundHintList(),
      {
        icon: PowerSettingsNewIcon,
        title: 'restartYourDevice',
        text: 'ifYourCameraIsInternalRestartYourDeviceAndTryAgain',
      },
    ],
  },
  'camera_not_available': {
    message: 'cameraNotAvailable',
    title: 'howCanIMakeMyCameraAvailable',
    hintList: [
      {
        icon: CancelPresentationIcon,
        title: 'appOrSoftwareConflict',
        text: 'ifAnotherAppOrSoftwareIsUsingYourCameraItMayNotBeAvailableForVideoConferences-closeAnyAppOrSoftwareThatIsSusceptibleToUseYourCameraSuchAsTeamsFaceTimeOrZoomAndRunTheCameraCheckAgain',
      },
      {
        icon: RefreshIcon,
        title: 'restartTheBrowser',
        text: 'ifYouDoNotHaveAnyPossiblyConflictingAppAndTheCheckStillFailsTryRefreshingThePage-ifItFailsAgainTryRestartingTheBrowser',
        buttonList: [{
          href: document.location.href,
          label: 'refresh',
          self: true,
        }],
      },
      {
        icon: PowerSettingsNewIcon,
        title: 'restartTheDevice',
        text: 'ifRestartingTheBrowserDidNotHelpTryRestartingYourDevice',
      },
    ],
  },
  'no_video_source': {
    message: 'noCameraDetected',
    title: 'addingCameras',
    hintList: [
      {
        icon: VideoCallIcon,
        title: 'plugInACamera',
        text: 'ifYouHaveAnExternalCameraTryPluggingItInAndRunTheCameraCheckAgain',
      },
      {
        icon: PhonelinkIcon,
        title: 'tryAnotherComputerOrSmartphone',
        text: 'ifYouDontHaveAnyExternalCameraToPlugInTryOpeningTheVideoConferenceLinkOnAnotherDevice-smartPhonesUsuallyHaveCameras',
      },
    ],
  },
};
